<template>
  <div
    class="deliveryTimeMapModule"
    v-if="delTimeFromStore"
    :falsePropVarant="currentStore && shouldModuleVisible"
  >
    <div v-if="shouldTopVisible" :style="getTopModuleMargin">
      <div class="custHeight">
        <template v-if="topBannerAnimation">
          <VueLottiePlayer
            name="offerIconAnim"
            width="100%"
            height="100%"
            :loop="false"
            :path="dataToShow?.Topbanneranimation"
          />
        </template>
        <template v-else-if="dataToShow?.TopBannerImage">
          <img
            :src="dataToShow?.TopBannerImage"
            :src-placeholder="getPlaceHolderImg"
            alt="banner image"
          />
        </template>
      </div>
    </div>
    <div v-if="shouldBottomVisible">
      <div
        @click="goto('pageTop')"
        :class="['bottom-sticky-widget', { mb44: shouldApplyCouponMargin }]"
        v-if="bottomImage && currentStatus"
      >
        <img
          :src="bottomImage"
          :src-placeholder="getPlaceHolderImg"
          alt="bottom sticky image"
        />
      </div>
    </div>
    <dot-20-modal
      v-if="showdot20Modal"
      :apiData="dot20ModalData"
      :headerImg="headerImg"
      :title="modalTitle"
    ></dot-20-modal>
  </div>
</template>

<script>
import { defineAsyncComponent } from "vue";
import setEvents from "../helpers/events";
import utility from "../helpers/utility.js";
import amplitude from "amplitude-js";
import LocalStorageFunc from "../helpers/localStorageFunc";
import { staticImgBaseUrl } from "../config/apiEndpoints";
import {
  keyMapsMutation,
  keyMapsGetter,
  keyMapsAction,
} from "../helpers/storeKeys";

export default {
  name: "DeliveryTimeMapDot20",
  props: ["moduleProps"],
  components: {
    Dot20Modal: defineAsyncComponent(() => import("./Dot20Modal.vue")),
  },
  data() {
    return {
      shouldTopVisible: false,
      modulePropsData: {},
      staticImgBaseUrl: staticImgBaseUrl,
      data: {},
      dataToShow: {},
      topBannerAnimation: false,
      currentStatus: 0,
      coupleApplied: 0,
      shouldBottomVisible: false,
      flagForFirstVisibiltyBottomIcon: false,
      bottomImage: "",
      headerImg: "",
      modalTitle: "",
      deliveryGuranteeKey: "",
      sgVal: "",
    };
  },
  mounted() {
    this.modulePropsData =
      typeof this.moduleProps != null &&
      typeof this.moduleProps != "null" &&
      typeof this.moduleProps != "undefined"
        ? JSON.parse(this.moduleProps)
        : {};

    const tempData = this.modulePropsData?.deliveryGuaranteeMap || "";

    this.data =
      typeof tempData != null &&
      typeof tempData != "null" &&
      typeof tempData != "undefined"
        ? JSON.parse(tempData)
        : {};

    this.currentStore;
  },
  destroyed() {
    window.removeEventListener("scroll", this.watchSticky);
  },
  methods: {
    eventFunction(isClicked = false, eObj = {}, isTop = true) {
      let eventType = isClicked ? "Click" : "nghDeliveryTimeImpression";
      let preEventObj = { ...eObj, positionWithinSection: "-1" };

      if (isClicked && !isTop) {
        preEventObj["category"] =
          this.modalTitle?.replace(/<[^>]*>/g, " ") || "";
      }
      const eventObj = utility.amplitudeEventObj(
        eventType,
        isTop ? "delivery banner" : "delivery floater icon",
        "-1",
        preEventObj
      );
      setEvents("amplitude", eventType, eventObj);
    },
    shouldTopVisibleModule(visiblity, duration, context) {
      if (visiblity) {
        let temp = context;
        setTimeout(() => {
          temp.shouldTopVisible = false;
          localStorage.setItem(
            "dot20_shouldDeliveryTimeTopBannnerVisible",
            false
          );
          localStorage.setItem(
            "dot20_storeForDeliveryTimeTopBannner",
            LocalStorageFunc.storeId()
          );
          if (temp.bottomImage) {
            temp.makeBottomWidgetVisible(temp);
            window.removeEventListener("scroll", this.watchSticky);
          }
        }, Number(duration));
      }
    },
    shouldBottomVisibleModule(visiblity, duration, context) {
      if (visiblity) {
        let temp = context;
        setTimeout(() => {
          temp.shouldBottomVisible = false;
          localStorage.setItem(
            "dot20_shouldDeliveryTimeBottomBannnerVisible",
            false
          );
          localStorage.setItem(
            "dot20_storeForDeliveryTimeBottomBannner",
            LocalStorageFunc.storeId()
          );
        }, Number(duration));
      }
    },
    goto() {
      this.$store.commit(keyMapsMutation.UPDATE_SHOW_LOADER_MODAL, true);
      this.$store.dispatch(keyMapsAction.GET_DOT_20_MODAL_DATA, {
        orderDeliveryType: this.currentOrderType,
        sgType: this.sgVal,
      });
      this.eventFunction(true, {}, false);
    },
    watchSticky() {
      if (this.bottomImage) {
        let value = window.pageYOffset;
        if (value > 150) {
          this.makeBottomWidgetVisible(this);
        } else {
          this.currentStatus = 0;
        }
      }
    },
    makeBottomWidgetVisible(context) {
      context.currentStatus = 1;
      if (!context.flagForFirstVisibiltyBottomIcon) {
        const bottomTimerOriginal = Number(
          context.dataToShow?.TopBannerVisibilityTime || 10000
        );
        const remainingBottomTimer = localStorage.getItem(
          "dot20_bottomTimeoutEnd"
        );

        if (
          remainingBottomTimer === undefined ||
          remainingBottomTimer === null ||
          remainingBottomTimer === ""
        ) {
          //fresh store - new timer
          context.flagForFirstVisibiltyBottomIcon = true;
          context.startTimeout(bottomTimerOriginal, false, context);
        } else if (Number(remainingBottomTimer) > 0) {
          context.flagForFirstVisibiltyBottomIcon = true;
          context.startTimeout(
            Number(remainingBottomTimer) * 1000,
            false,
            context
          );
        } else {
          return;
        }
      }
    },
    startTimeout(duration, isTopWidget = true, context = this) {
      const startTime = Date.now();
      const endTime = startTime + duration;
      let flagTop = false;
      let flagBottom = false;

      const logTimeRemaining = () => {
        const remainingTime = endTime - Date.now();

        if (isTopWidget) {
          if (remainingTime > 0) {
            if (!flagTop) {
              flagTop = true;
              context.shouldTopVisible = true;
              context.shouldTopVisibleModule(true, duration, context);
              context.eventFunction(false, {}, true);
            }
            localStorage.setItem(
              "dot20_topTimeoutEnd",
              parseInt(remainingTime / 1000)
            );
          } else {
            localStorage.removeItem("dot20_topTimeoutEnd"); // Remove timeout data after it expires
            clearInterval(interval);
          }
        } else {
          if (remainingTime > 0) {
            if (!flagBottom) {
              flagBottom = true;
              context.eventFunction(false, {}, false);
              context.shouldBottomVisibleModule(true, duration, context);
            }

            localStorage.setItem(
              "dot20_bottomTimeoutEnd",
              parseInt(remainingTime / 1000)
            );
          } else {
            localStorage.removeItem("dot20_bottomTimeoutEnd"); // Remove timeout data after it expires
            clearInterval(interval);
          }
        }
      };

      logTimeRemaining();
      const interval = setInterval(logTimeRemaining, 1000);
    },
  },

  computed: {
    delTimeFromStore() {
      const { timeServiceGuarantee = {} } =
        this.$store.state.Location.storeDetails;

      const { type = "", deliveryETA = "" } = timeServiceGuarantee;
      let actualDeliveryETA = parseInt(deliveryETA) || 0;

      if (!this.getLocationSource && this.currentOrderType == "D" && timeServiceGuarantee !== null) {
        let key = "";
        if (type && Number(type)) {
          key = "type";
          this.sgVal = type;
        } else if (actualDeliveryETA && Number(actualDeliveryETA)) {
          key = "deliveryETA";
          this.sgVal = actualDeliveryETA;
        } else {
          return false;
        }

        const temp = this.data[timeServiceGuarantee[key]] || {};
        this.topBannerAnimation = temp?.Topbanneranimation ? true : false;
        this.bottomImage =
          temp?.bottom_sticky_image && temp?.bottom_sticky_image;
        this.dataToShow = temp;
        this.headerImg = temp?.titleLeftIcon || "";
        this.modalTitle = temp?.title || "";

        if (key == "deliveryETA") {
          this.$store.commit(
            keyMapsMutation.UPDATE_DELIVERY_TAB_VALUE_FOR_DELIVERY_ETA_CASE,
            this.dataToShow?.deliveryTabValue || ""
          );
        }
        if (key && Object.keys(this.dataToShow).length > 0) {
          window.addEventListener("scroll", this.watchSticky);
        }
        return key ? String(timeServiceGuarantee[key]) : false;
      } else {
        return false;
      }
    },
    currentOrderType() {
      return this.$store.state.User.currentOrderType;
    },
    currentStore() {
      let currentStore = LocalStorageFunc.storeId();
      let storeForDeliveryTimeTopBannnerIs =
        localStorage.getItem("dot20_storeForDeliveryTimeTopBannner") || null;
      let storeForDeliveryTimeBottomBannnerIs =
        localStorage.getItem("dot20_storeForDeliveryTimeBottomBannner") || null;

      if (
        storeForDeliveryTimeTopBannnerIs &&
        currentStore != storeForDeliveryTimeTopBannnerIs
      ) {
        localStorage.setItem("dot20_storeForDeliveryTimeTopBannner", ""); //new dot 20 store
        storeForDeliveryTimeTopBannnerIs = "";
      }
      if (
        storeForDeliveryTimeBottomBannnerIs &&
        currentStore != storeForDeliveryTimeBottomBannnerIs
      ) {
        localStorage.setItem("dot20_storeForDeliveryTimeBottomBannner", "");
        storeForDeliveryTimeBottomBannnerIs = "";
        localStorage.setItem("dot20_bottomTimeoutEnd", "");
      }

      if (this.delTimeFromStore) {
        let deliveryTimeTopBannerVisibilty = JSON.parse(
          localStorage.getItem("dot20_shouldDeliveryTimeTopBannnerVisible")
        );
        let deliveryTimeBottomBannerVisibilty = JSON.parse(
          localStorage.getItem("dot20_shouldDeliveryTimeBottomBannnerVisible")
        );
        let preStore = localStorage.getItem("previousStoreId");
        //top
        if (
          deliveryTimeTopBannerVisibilty === undefined ||
          deliveryTimeTopBannerVisibilty === null
        ) {
          localStorage.setItem(
            "dot20_shouldDeliveryTimeTopBannnerVisible",
            true
          );
          deliveryTimeTopBannerVisibilty = true; //first time
        } else if (
          preStore &&
          currentStore != preStore &&
          deliveryTimeTopBannerVisibilty === false &&
          storeForDeliveryTimeTopBannnerIs != currentStore
        ) {
          localStorage.setItem(
            "dot20_shouldDeliveryTimeTopBannnerVisible",
            true
          ); //new banner store
          deliveryTimeTopBannerVisibilty = true;
        }
        //bottom
        if (
          deliveryTimeBottomBannerVisibilty === undefined ||
          deliveryTimeBottomBannerVisibilty === null
        ) {
          localStorage.setItem(
            "dot20_shouldDeliveryTimeBottomBannnerVisible",
            true
          );
          deliveryTimeBottomBannerVisibilty = true;
        } else if (
          preStore &&
          currentStore != preStore &&
          deliveryTimeBottomBannerVisibilty === false &&
          storeForDeliveryTimeBottomBannnerIs != currentStore
        ) {
          localStorage.setItem(
            "dot20_shouldDeliveryTimeBottomBannnerVisible",
            true
          ); //new banner store
          deliveryTimeBottomBannerVisibilty = true;
        }

        if (preStore && currentStore != preStore) {
          localStorage.setItem("dot20_topTimeoutEnd", "");
          localStorage.setItem("dot20_bottomTimeoutEnd", "");
        }
        //timeouts
        if (currentStore && Object.keys(this.dataToShow).length > 0) {
          if (preStore != currentStore) {
            if (deliveryTimeTopBannerVisibilty) {
              const topTimerOriginal = Number(
                this.dataToShow?.TopBannerVisibilityTime || 10000
              );
              const remainingTopTimer = localStorage.getItem(
                "dot20_topTimeoutEnd"
              );

              if (
                remainingTopTimer === undefined ||
                remainingTopTimer === null ||
                remainingTopTimer === ""
              ) {
                //fresh store - new timer
                this.startTimeout(topTimerOriginal);
              } else if (Number(remainingTopTimer) > 0) {
                this.startTimeout(Number(remainingTopTimer) * 1000);
              } else {
                return;
              }
            }
            if (deliveryTimeBottomBannerVisibilty && this.bottomImage) {
              this.shouldBottomVisible = true;
              if (!deliveryTimeTopBannerVisibilty) {
                //top widget timeout expired for this store - bottom should be visible forcely
                this.makeBottomWidgetVisible(this);
                window.removeEventListener("scroll", this.watchSticky);
              }
            }
          }
        }

        return currentStore;
      } else {
        return false;
      }
    },
    showdot20Modal() {
      return this.$store.state.DynamicWidget.dot20ModalFlag;
    },
    getPlaceHolderImg() {
      const img =
        this.$store.getters[keyMapsGetter.GET_PLACE_HOLDER_IMAGE]?.rect;
      const fallBack =
        staticImgBaseUrl + "/images/global/default-product-img-lg.png";
      return img || fallBack;
    },
    dot20ModalData() {
      return this.$store.state.DynamicWidget.dot20ModalData;
    },
    shouldModuleVisible() {
      let _ = this.shouldBottomVisible || this.shouldTopVisible;
      if (!_) {
        window.removeEventListener("scroll", this.watchSticky);
      }
    },
    shouldApplyCouponMargin() {
      const offerApplied = this.$store.state.Offers.selectedOfferIndex !== -1;
      const dealModule = this.$store.state.DynamicWidget.isBottomNudgeVisible;
      if (offerApplied || dealModule) {
        return true;
      } else {
        return false;
      }
    },
    getTopModuleMargin() {
      const top = this.modulePropsData?.topMargin;
      const bottom = this.modulePropsData?.bottomMargin;
      const _ = {
        marginTop: top + "px",
        marginBottom: bottom + "px"
      };
      return _;
    },
    getLocationSource(){
      return this.$store.state.Location?.locationType?.toLowerCase() == "ip";
    }
  },
};
</script>
